import type { ImportReport } from "../../data/index.ts";
import { store, toast } from "../state.ts";
import { showCaptured } from "./Captured.tsx";

// Dono: B5. Chamado no boot depois de store.start: transforma o que o Android compartilhou (share target) em cards.
// O service worker grava cada compartilhamento na caixa "shareInbox" (IndexedDB faig-share) e abre /?shared=1. Sem rede
// os cards nascem na fila de saída e sobem depois (escrita otimista do store). Depois, /capturado abre a folha de
// confirmação e, se a pessoa quiser, etiquetas e anotação para esses cards (Captured.tsx).
export async function consumeShares(): Promise<void> {
  const flag = new URLSearchParams(location.search).get("shared");
  if (flag !== null) history.replaceState(null, "", location.pathname + location.hash);
  if (flag === "0") toast({ key: "shared-fail", text: "Não deu para receber o que foi compartilhado. Tente de novo." });
  let ids: string[];
  try {
    ids = await store.consumeSharedItems();
  } catch {
    if (flag !== null) toast({ key: "shared-fail", text: "Não deu para guardar o que foi compartilhado. Tente de novo." });
    return;
  }
  if (!ids.length) return;
  // §10.4: no primeiro uso, pede ao navegador para não apagar a cópia local (no Android ele decide sem perguntar).
  void navigator.storage?.persist?.().catch(() => {});
  // A folha diz "Guardado." (com "Ver" e o aviso de sem conexão): um aviso a mais aqui repetiria o mesmo.
  showCaptured(ids);
}

const count = (n: number, one: string, many: string) => `${n.toLocaleString("pt-BR")} ${n === 1 ? one : many}`;
export const importText = (r: ImportReport) =>
  `Importação concluída: ${count(r.created, "card novo", "cards novos")} · ${r.duplicates.toLocaleString("pt-BR")} já ${r.duplicates === 1 ? "estava" : "estavam"} aqui · ${r.failed.toLocaleString("pt-BR")} com problema.`;

/** Notas em arquivo: o que importFiles transforma em nota (Markdown com títulos, listas e tarefas; texto puro). */
export const isNoteFile = (f: File) => /\.(md|markdown|txt)$/i.test(f.name);

/** .md/.txt arrastados ou colados em qualquer tela (F4 aceite 14): mesma importação da Conta, relatório num aviso. */
export function importNoteFiles(files: File[]) {
  if (!store.status.peek().online) return toast({ key: "import-offline", text: "Importar notas .md e .txt precisa de conexão." });
  toast({ key: "importing", text: `Importando ${count(files.length, "arquivo", "arquivos")}…` }, 4000);
  store.importFiles(files).then(
    (r) => toast({ key: `imported:${Date.now()}`, text: importText(r) }, 8000),
    () => {}, // o store já avisou o motivo
  );
}
